export default __webpack_public_path__ + "static/media/Typescript.e0cf5672.svg";